import React, { useEffect, useState } from 'react';
import './Dashboard.scss';
import { useHistory } from 'react-router-dom';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { FaUserClock } from 'react-icons/fa';
import { FaHouseChimneyUser } from 'react-icons/fa6';
import { TiTick } from 'react-icons/ti';
import { fetchStatistics } from '../../services/api';

const Dashboard = () => {
  const [statistics, setStatistics] = useState({
    totalBlocks: 0,
    totalSupervisors: 0,
    totalHouses: 0,
    inspectionDone: 0
  });

  const history = useHistory();

  const fetchStatistic = async () => {
    try {
      const response = await fetchStatistics();
      const data = response.data;

      setStatistics({
        totalBlocks: data.totalBlocks,
        totalSupervisors: data.totalSupervisors,
        totalHouses: data.totalHouses,
        inspectionDone: data.inspectionDone
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchStatistic();
  }, []);

  const handleCardClick = (route) => {
    history.push(route);
  };

  return (
    <div className='dashboard-container'>
      <div className='dashboard-card blocks-card' onClick={() => handleCardClick('/blockmanagement')}>
        <div className='icon-container icon-blocks'>
          <HiOutlineUserGroup />
        </div>
        <div className='dashboard-details'>
          <p>Blocks</p>
          <h4>{statistics.totalBlocks}</h4>
        </div>
      </div>

      <div className='dashboard-card supervisor-card' onClick={() => handleCardClick('/supervisor')}>
        <div className='icon-container icon-supervisor'>
          <FaUserClock />
        </div>
        <div className='dashboard-details'>
          <p>Supervisors</p>
          <h4>{statistics.totalSupervisors}</h4>
        </div>
      </div>

      <div className='dashboard-card house-card' onClick={() => handleCardClick('/housedetails')}>
        <div className='icon-container icon-house'>
          <FaHouseChimneyUser />
        </div>
        <div className='dashboard-details'>
          <p>Houses</p>
          <h4>{statistics.totalHouses.toLocaleString()}</h4>
        </div>
      </div>

      <div className='dashboard-card inspection-card' onClick={() => handleCardClick('/report')}>
        <div className='icon-container icon-inspection'>
          <TiTick />
        </div>
        <div className='dashboard-details'>
          <p>Inspections Done</p>
          <h4>{statistics.inspectionDone}</h4>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
